import React from "react";

const StepTowardsSection = () => {
  return (
    <div
      className="section-full p-t150 p-b120 site-bg-dark twm-step-towards-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2s"
    >
      <div
        className="twm-half-bg-pic"
        style={{ backgroundImage: "url(images/half-bg-pic.jpg)" }}
      ></div>

      <div className="container">

        {/* TITLE ROW */}
        <div className="row">
          <div className="col-lg-6 col-md-12">

            <div className="section-head left">
              <div className="twm-sm-title left">
                Travel With Comfort
              </div>

              <h2 className="twm-large-title site-text-white text-white">
                Start Your Journey With Shivai Travels
              </h2>
            </div>

          </div>
        </div>

        {/* CONTENT */}
        <div className="section-content">
          <div className="row twm-step-towards-section">

            {/* Item 1 */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img src="images/icons/label.png" alt="Affordable Pricing" />
                </div>

                <div className="twm-content">
                  <h3 className="twm-title">
                    Affordable Cab Packages
                  </h3>

                  <p>
                    Get the best pricing for local rides, outstation trips,
                    airport transfers, and corporate travel with no hidden charges.
                  </p>
                </div>
              </div>
            </div>

            {/* Item 2 */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img
                    src="images/icons/customer-support.png"
                    alt="24/7 Support"
                  />
                </div>

                <div className="twm-content">
                  <h3 className="twm-title">
                    24/7 Customer Support
                  </h3>

                  <p>
                    Our support team and drivers are always available to ensure
                    a safe, smooth, and hassle-free travel experience anytime.
                  </p>
                </div>
              </div>
            </div>

            {/* Item 3 */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img
                    src="images/icons/parking-area.png"
                    alt="Pickup & Drop"
                  />
                </div>

                <div className="twm-content">
                  <h3 className="twm-title">
                    Doorstep Pick-Up & Drop
                  </h3>

                  <p>
                    Enjoy convenient pickup and drop services right from your
                    location with professional and punctual drivers.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default StepTowardsSection;